import styled from 'styled-components';

export const WelcomeText = styled.div`
  padding: 12px 8px 6px 8px;
`;
